import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import { getProductCardIconWithTooltip } from '../../utils/productCardUtils';
import replaceInteriorsByDragAndDrop from '../../behaviors/replaceInteriorsByDragAndDrop';
import { sortInteriors } from 'rangeConfig/kallax/sorting/sort';
import { getBoxes, getInserts } from 'rangeConfig/kallax/filters/mainMenuProductFilters';

const interiorsProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  infoButtonAriaLabel: 'storageone.productListInteriorsTitle',
  sortClusteredProducts: sortInteriors,
  sortOrder: [],
  categories: [
    {
      id: 'interiors',
      categoryTitle: 'storageone.insertsSubcategoryTitle',
      products: [
        { path: 'type', value: ProductType.KALLAX_DRAWERS },
        { path: 'type', value: ProductType.KALLAX_DIVIDERS },
        { path: 'type', value: ProductType.KALLAX_CABINETS },
        { path: 'type', value: ProductType.KALLAX_BOXES },
        { path: 'type', value: ProductType.KALLAX_BASKETS }
      ]
    }
  ],
  productFilters: [getInserts],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [replaceInteriorsByDragAndDrop]
  },
  cluster: ['globalItemNo'],
  productCardIcon: getProductCardIconWithTooltip
};

const boxesProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  infoButtonAriaLabel: 'storageone.productListInteriorsTitle',
  sortClusteredProducts: sortInteriors,
  sortOrder: [],
  categories: [
    {
      id: 'boxes',
      categoryTitle: 'storageone.boxesSubcategoryTitle',
      products: [
        { path: 'type', value: ProductType.KALLAX_DRAWERS },
        { path: 'type', value: ProductType.KALLAX_DIVIDERS },
        { path: 'type', value: ProductType.KALLAX_CABINETS },
        { path: 'type', value: ProductType.KALLAX_BOXES },
        { path: 'type', value: ProductType.KALLAX_BASKETS }
      ]
    }
  ],
  productFilters: [getBoxes],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [replaceInteriorsByDragAndDrop]
  },
  cluster: ['globalItemNo'],
  productCardIcon: getProductCardIconWithTooltip
};

export { interiorsProductListConfig, boxesProductListConfig };
